'use strict';

angular.module('amexReconciliationApp')
  .component('transactionApprovalsHeader', {
    templateUrl: 'scripts/views/components/transaction-approvals-header.html',
    controller: function (SiteConfigModel, TransactionSortModel) {
      var self = this;

      self.approvalEnabledForBcaManager = SiteConfigModel.approvalEnabledForBcaManager;
      self.approvalEnabledForCardManager = SiteConfigModel.approvalEnabledForCardManager;
      self.approvalEnabledForAccountingManager = SiteConfigModel.approvalEnabledForAccountingManager;
      self.approvalEnabledForCardmember = SiteConfigModel.approvalEnabledForCardmember;
      
      self.sortByCardmember = function() {
        TransactionSortModel.setSortField('mutableTransactionProperties.cardmemberSubmitted');
      };

      self.sortByCardManager = function() {
        TransactionSortModel.setSortField('mutableTransactionProperties.cardManagerApproved');
      };

      self.sortByBcaManager = function() {
        TransactionSortModel.setSortField('mutableTransactionProperties.bcaManagerApproved');
      };

      self.sortByAccountingManager = function() {
        TransactionSortModel.setSortField('mutableTransactionProperties.accountingManagerApproved');
      };
    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/transactionApprovalsHeader.js
// module id = 484
// module chunks = 0